import $api, {API_URL} from "./instance";
import errorMessage from "../const/Tost";

export const commonServices = {
    async getByParam(url, data){
        try{
            return await $api.get(`${API_URL}${url}?${data}`);
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async deleteUser(url, id){
        try{
            return await $api.delete(`${API_URL}/${url}/${id}`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getAllWorkerBasicList(){
        try{
            return await $api.get(`${API_URL}/user/basic-info`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }
};